import {Navigate, Route, Routes} from 'react-router-dom';
import {MasterLayout} from '../../_metronic/layout/MasterLayout';
import {routesConfig} from './routesConfig';
import PageTransitionLoader from './PageTransitionLoader';
import SecuredComponent from '../modules/auth/authorization/SecuredComponent';
import NewsPopupModal from '../pages/dashboard/currently/NewsPopupModal';
// import EvolutionAnnouncementModal from '../common/components/modal/EvolutionAnnouncementModal';
// import ClientInfoModal from '../common/components/modal/ClientInfoModal';

const renderRoutes = (routes: any, parentPath = '') => {
  return routes.map((route: any) => {
    // Génère une clé unique (pour éviter le duplicatee key warning)
    const fullPath = `${parentPath}/${route.path || ''}`.replace('//', '/');
    const key = route.path || fullPath;

    if (route.children) {
      return (
        <Route path={route.path} key={key} element={route.element}>
          {renderRoutes(route.children, fullPath)}
        </Route>
      );
    }

    // if it's an index route
    if (route.index) {
      return <Route index element={route.element} key={key} />;
    }

    // route without children and not an index route
    return <Route path={route.path} key={key} element={route.element} />;
  });
};

const PrivateRoutes = () => {
  return (
    <>
      {/* <EvolutionAnnouncementModal /> temporairement désactivé */}
      <SecuredComponent requiredPermissions={['voirEnCeMoment']}>
        <NewsPopupModal />
      </SecuredComponent>
      <Routes>
        <Route element={<MasterLayout />}>
          <Route element={<PageTransitionLoader />}>
            <Route path="auth/*" element={<Navigate to="/dashboard" />} />
            {renderRoutes(routesConfig)}
            <Route path="*" element={<Navigate to="/error/404" />} />
          </Route>
        </Route>
      </Routes>
    </>
  );
};

export {PrivateRoutes};
